<template>
    <b-container fluid>
        <b-row>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Estudia Actualmente"
                    :has-error="$v.userInfo.isCurrentlyStudying.$error"
                    @input="$v.userInfo.isCurrentlyStudying.$touch()"
                    v-model="userInfo.isCurrentlyStudying"
                    :options="isCurrentlyStudyingOptions"
                    :required="true"
                    @change="onIsCurrentlyStudyingChange"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    label="Horario"
                    :has-error="$v.userInfo.studyHours.$error"
                    @input="$v.userInfo.studyHours.$touch()"
                    v-model="userInfo.studyHours"
                    :required="true"
                    :disabled="!studying"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    label="Semestre / avance"
                    :has-error="$v.userInfo.studyProgress.$error"
                    @input="$v.userInfo.studyProgress.$touch()"
                    v-model="userInfo.studyProgress"
                    :required="true"
                    :disabled="!studying"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    label="Carrera / Programa"
                    :has-error="$v.userInfo.studyProgram.$error"
                    @input="$v.userInfo.studyProgram.$touch()"
                    v-model="userInfo.studyProgram"
                    :required="true"
                    :disabled="!studying"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-input
                    label="Institución educativa"
                    :has-error="$v.userInfo.educationalInstitution.$error"
                    @input="$v.userInfo.educationalInstitution.$touch()"
                    v-model="userInfo.educationalInstitution"
                    :required="true"
                    :disabled="!studying"
                ></app-form-input>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Talla de chaqueta"
                    :has-error="$v.userInfo.jacketSize.$error"
                    @input="$v.userInfo.jacketSize.$touch()"
                    v-model="userInfo.jacketSize"
                    :options="sizes"
                    :required="true"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Talla de camisa"
                    :has-error="$v.userInfo.shirtSize.$error"
                    @input="$v.userInfo.shirtSize.$touch()"
                    v-model="userInfo.shirtSize"
                    :options="sizes"
                    :required="true"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Talla de pantalon"
                    :has-error="$v.userInfo.pantsSize.$error"
                    @input="$v.userInfo.pantsSize.$touch()"
                    v-model="userInfo.pantsSize"
                    :options="sizes"
                    :required="true"
                ></app-form-select>
            </b-col>
            <b-col class="py-2" cols="12" md="4" lg="4">
                <app-form-select
                    label="Talla de zapatos"
                    :has-error="$v.userInfo.shoesSize.$error"
                    @input="$v.userInfo.shoesSize.$touch()"
                    v-model="userInfo.shoesSize"
                    :options="shoesSizes"
                    :required="true"
                ></app-form-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-sub-title
                    text="Familiares (Describa con quien vive)"
                ></app-sub-title>
            </b-col>
        </b-row>
        <b-form-row align-v="end">
            <b-col cols="12" md="3" lg="3">
                <app-form-input
                    label="Nombre"
                    v-model="familyMember.name"
                    :has-error="$v.familyMember.name.$error"
                    @input="$v.familyMember.name.$touch()"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col cols="12" md="3" lg="2">
                <app-form-input
                    label="Parentesco"
                    v-model="familyMember.relationship"
                    :has-error="$v.familyMember.relationship.$error"
                    @input="$v.familyMember.relationship.$touch()"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col cols="12" md="3" lg="2">
                <app-form-input
                    label="Edad"
                    v-model="familyMember.age"
                    :has-error="$v.familyMember.age.$error"
                    @input="$v.familyMember.age.$touch()"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col cols="12" md="3" lg="2">
                <app-form-input
                    label="Ocupación"
                    v-model="familyMember.ocupation"
                    :has-error="$v.familyMember.ocupation.$error"
                    @input="$v.familyMember.ocupation.$touch()"
                    :required="true"
                ></app-form-input>
            </b-col>
            <b-col cols="12" md="3" lg="2">
                <app-form-input
                    label="Empresa"
                    v-model="familyMember.company"
                ></app-form-input>
            </b-col>
            <b-col cols="12" md="3" lg="1" align-self="end">
                <label for="">&nbsp;</label>
                <b-btn block variant="primary" @click="addFamilyMember"
                    ><i class="fa fa-plus"></i
                ></b-btn>
            </b-col>
        </b-form-row>
        <b-row v-if="userInfo.familyMembers.length > 0" class="mt-2">
            <b-col>
                <app-data-table
                    :fields="familyFields"
                    :items="userInfo.familyMembers"
                >
                    <template slot="actions" slot-scope="data">
                        <b-btn
                            variant="danger"
                            @click="removeFamilyMember(data.index)"
                            ><i class="fa fa-trash"></i
                        ></b-btn>
                    </template>
                </app-data-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import usersRepository from "../../../../repositories/users.repository";
export default {
    data: () => ({
        userInfo: {
            isCurrentlyStudying: "",
            studyHours: "",
            studyProgress: "",
            studyProgram: "",
            educationalInstitution: "",
            jacketSize: "",
            shirtSize: "",
            pantsSize: "",
            shoesSize: "",
            familyMembers: []
        },
        isCurrentlyStudyingOptions,
        sizes,
        shoesSizes,
        familyFields,
        familyMember: {
            name: "",
            relationship: "",
            age: "",
            ocupation: "",
            company: ""
        }
    }),
    validations: {
        userInfo: {
            isCurrentlyStudying: { required },
            studyHours: { requiredIf: requiredIf("studying") },
            studyProgress: { requiredIf: requiredIf("studying") },
            studyProgram: { requiredIf: requiredIf("studying") },
            educationalInstitution: { requiredIf: requiredIf("studying") },
            jacketSize: { required },
            shirtSize: { required },
            pantsSize: { required },
            shoesSize: { required }
        },
        familyMember: {
            name: { required },
            relationship: { required },
            age: { required },
            ocupation: { required }
        }
    },
    computed: {
        studying() {
            return this.userInfo.isCurrentlyStudying === "SI";
        }
    },
    methods: {
        addFamilyMember() {
            this.$v.familyMember.$touch();

            if (this.$v.familyMember.$invalid) return false;

            this.userInfo.familyMembers.push({ ...this.familyMember });
            this.$v.familyMember.$reset();
            Object.keys(this.familyMember).map(
                key => (this.familyMember[key] = "")
            );
        },
        removeFamilyMember(index) {
            this.userInfo.familyMembers.splice(index, 1);
        },
        async saveInfo() {
            if (!!this.familyMember.name) {
                this.addFamilyMember();
                if (this.$v.familyMember.$invalid) return false;
            }

            const ur = { ...usersRepository };
            try {
                const { data } = await ur.saveUserInfo2(
                    this.user.id,
                    this.userInfo
                );
                if (!data.status) return toastr.error(data.msg);
                this.$emit("saved", data);
            } catch (err) {
                this.handleErrors(err);
            } finally {
            }
        },
        onIsCurrentlyStudyingChange(val) {
            if (val !== "SI") {
                this.userInfo.studyHours = "";
                this.userInfo.studyProgress = "";
                this.userInfo.studyProgram = "";
                this.userInfo.educationalInstitution = "";
            }
        }
    },
    mounted() {
        this.$bus.$on("userInfoForm.save", this.saveInfo);
    },
    beforeDestroy() {
        this.$bus.$off("userInfoForm.save");
    }
};
const isCurrentlyStudyingOptions = [
    {
        value: "SI",
        text: "Si"
    },
    {
        value: "NO",
        text: "No"
    }
];

const sizes = [
    {
        value: "S",
        text: "S"
    },
    {
        value: "M",
        text: "M"
    },
    {
        value: "L",
        text: "L"
    },
    {
        value: "XL",
        text: "XL"
    }
];

const shoesSizes = [
    {
        value: 32,
        text: "32"
    },
    {
        value: 34,
        text: "34"
    },
    {
        value: 36,
        text: "36"
    },
    {
        value: 38,
        text: "38"
    },
    {
        value: 40,
        text: "40"
    },
    {
        value: 42,
        text: "42"
    },
    {
        value: 44,
        text: "44"
    },
    {
        value: 46,
        text: "46"
    }
];

const familyFields = [
    {
        key: "name",
        label: "Nombre"
    },
    {
        key: "relationship",
        label: "Parentezco"
    },
    {
        key: "age",
        label: "Edad"
    },
    {
        key: "ocupation",
        label: "Ocupación"
    },
    {
        key: "company",
        label: "Empresa"
    },
    {
        key: "actions",
        label: "Acciones"
    }
];
</script>
